/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
/* import */
import { Auth } from "aws-amplify";
import AWSAppSyncClient, { AUTH_TYPE, createAppSyncLink } from 'aws-appsync';
/* AWS settings */
import { AppsyncCdkRdsStack } from '../cdk-exports.json';
import { AppsyncStudyCdkRdsStack } from "../cdk-exports-study.json";
// import { AppsyncCdkRdsStack as AppsyncStudyCdkRdsStack } from "../cdk-exports.json";
import { ApolloLink } from 'apollo-link';
const { createHttpLink } = require('apollo-link-http');
const { setContext } = require('apollo-link-context');
/*******************************************************************************
 * main
 ******************************************************************************/

class SwitchClientLink {
  constructor (options) {
    this.AppSyncClient = null;

    // this.init()
  };

  /**
   * 根据用户名切换appSync endpoint 
   * username: democlinical => AppsyncCdkRdsStack
   * username: demolab => AppsyncStudyCdkRdsStack
   */
  async init() {
    let authResult = await Auth.currentAuthenticatedUser();
    let cdkStack = this.getCdkRdsStack(authResult);
    let appSyncConfig = this.appSyncCfg(cdkStack);
    let link = this.createAscLink(appSyncConfig, cdkStack);

    if (cdkStack.ProjectRegion === "cn-north-1") {
      console.log("appSync run ---- china", cdkStack);
      this.AppSyncClient = new AWSAppSyncClient(appSyncConfig, { link });
    } else {
      console.log("appSync run ---- America", cdkStack);
      this.AppSyncClient = new AWSAppSyncClient(appSyncConfig);
    };
    return this.AppSyncClient
  };

  /**
   * 获取当前需要的AppsyncCdkRdsStack文件 cdk-exports*.json
   * @param { Auth } param 当前登录的用户信息
   * @returns Object
   */
  getCdkRdsStack({username}) {
    if(username === "democlinical") {
      return AppsyncCdkRdsStack
    };
    return AppsyncStudyCdkRdsStack;
  };

  /**
   * 创建appSyncConfig
   * @param { Object } param AppsyncCdkRdsStack
   * @returns configObject
   */
  appSyncCfg({AppSyncAPIURL, ProjectRegion}) {
    return {
      url: AppSyncAPIURL,
      region: ProjectRegion,
      auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken(),
      },
    }
  };

  /**
   * 创建AppsyncLink
   * @param { Object } appSyncConfig appSyncConfig配置对象 appSyncCfg的运行结果
   * @param { Object } appSyncCdkStack AppsyncCdkRdsStack
   * @returns 
   */
  createAscLink(appSyncConfig, appSyncCdkStack) {
    return createAppSyncLink({
      ...appSyncConfig,
      resultsFetcherLink: ApolloLink.from([
        setContext(( request, previousContext ) => ({
          headers: {
            ...previousContext.headers,
            'X-API-KEY': appSyncCdkStack.AppSyncAPIKey
          },
        })),
        createHttpLink({ uri: appSyncConfig.url })
      ])
    })
  };



  async query( params ) {
    // return this.AppSyncClient.query(params)
    if( window.appSyncClient ) {
      return window.appSyncClient.query(params)
    };

    let appSyncClient = await this.init();
    window.appSyncClient = appSyncClient;
    return appSyncClient.query(params)
  };

  async mutate(params) {
    // return this.AppSyncClient.mutate(params)
    if( window.appSyncClient ) {
      return window.appSyncClient.mutate(params)
    };

    let appSyncClient = await this.init();
    window.appSyncClient = appSyncClient;
    return appSyncClient.mutate(params)
  }
};

let switchClientLink = new SwitchClientLink();

export default switchClientLink;